<template>
  <div>
    <v-overlay :value="params.shows" z-index="300">
      <v-progress-circular indeterminate :size="params.size || 64"></v-progress-circular>
    </v-overlay>

    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-text>
          <span class="red--text">{{ $t("biz_admin_timeout") }}</span>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="dialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import { createComponent, PropType, value, watch, Wrapper } from "vue-function-api";
import { ProgressCircularCtrls } from "@/framework/types/progressCircularCtrls";

export default createComponent({
  props: ["controls"] as any as PropType<{ controls: ProgressCircularCtrls }>,
  setup(props, context) {
    const params: ProgressCircularCtrls = props.controls;
    const timeout = 300000; // params.timeout ? params.timeout : 10 * 1000;
    const btnCtrlOverlayTimer: Wrapper<number> = value(0);
    const dialog = value(false);

    watch(
      () => params.shows,
      (newVal, oldVal) => {
        if (params.timeout === -1) return;

        if (newVal && !oldVal) {
          btnCtrlOverlayTimer.value = window.setTimeout(() => {
            params.shows = false;
            dialog.value = true;
          }, timeout);
        }
        if (!newVal && oldVal) {
          window.clearTimeout(btnCtrlOverlayTimer.value);
        }
      }
    );

    return {
      params,
      dialog,
    };
  },
});
</script>

<style scoped></style>
